import React, { useState } from "react";
import { Link } from "react-router-dom";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center">

                {/* LOGO */}
                <div className="col-md-4 col-8">
                    <div style={{ paddingLeft: "10%", paddingTop: "10px", paddingBottom: "10px" }}>
                        <div style={{float:'left',width:'80px'}}>
                            <img src="./images/logo.jpg" style={{ width: "100%" }} alt="logo" />
                        </div>
                        <div style={{float:'left'}}>
                            <span className="templename">
                               Thirunelly Sree Mahavishnu Temple
                               </span><br />
                            <span className="makreri-templename">
                               തിരുനെല്ലി ശ്രീ മഹാവിഷ്ണു ക്ഷേത്രം <br /> &nbsp;
                               ತಿರುನೆಲ್ಲಿ ಶ್ರೀ ಮಹಾವಿಷ್ಣು ದೇವಸ್ಥಾನ
                            </span>
                        </div>


                    </div>
                </div>

                {/* HAMBURGER BUTTON (Mobile only) */}
                <div className="col-4 d-md-none text-end pe-4">
                    <button
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                </div>

                {/* MENU ITEMS */}
                {/* MENU ITEMS */}
                <div className={`col-md-8 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Home
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/History" className="menuitems" onClick={closeMenu}>
                                About Temple
                            </Link>
                        </div>

                        <div className="boxes">
                            <a
                                href="https://booking.thirunellytemple.in/"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                Online Booking
                            </a>
                        </div>

                        {/* <div className="boxes">
                            <Link to="/Timing" className="menuitems" onClick={closeMenu}>
                                Darsan Time
                            </Link>
                        </div> */}

                        <div className="boxes">
                            <Link to="/Accommodation" className="menuitems" onClick={closeMenu}>
                                Accommodation
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Administration" className="menuitems" onClick={closeMenu}>
                                Administration
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Gallery" className="menuitems" onClick={closeMenu}>
                                Gallery
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Contact" className="menuitems" onClick={closeMenu}>
                                Contact
                            </Link>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    );
}

export default MainMenu;
